export const getErrorMsg = (withAction) => (
  `Sorry, there was an error ${withAction}. Please try again.`
);
